import { render, staticRenderFns } from "./DownloadIcon.vue?vue&type=template&id=279b95a9&scoped=true&functional=true&"
import script from "./DownloadIcon.vue?vue&type=script&lang=js&"
export * from "./DownloadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "279b95a9",
  null
  
)

export default component.exports